import { render, staticRenderFns } from "./PD.vue?vue&type=template&id=e3d8de58&"
import script from "./PD.vue?vue&type=script&lang=js&"
export * from "./PD.vue?vue&type=script&lang=js&"
import style0 from "./PD.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports